/*
 * Built-in product reviews (sections/product-reviews.liquid, snippets/review-badge.liquid)
 * - Badge link: smooth scroll to #customer-reviews below the sticky header
 * - Reviews list: client-side sort, "With Photos" filter, pagination, photo lightbox
 * - Write a review: star input, validation, photo/video previews, submit via
 *   Shopify contact form (email mode) or the Cloudflare Worker (automatic mode)
 */
(function () {
  if (window.MelaroReviews) return;
  window.MelaroReviews = true;

  var PHOTO_MAX = 5;
  var PHOTO_MAX_BYTES = 20 * 1024 * 1024;
  var PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  var VIDEO_MAX_BYTES = 100 * 1024 * 1024;
  var VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function headerOffset() {
    var candidates = document.querySelectorAll(
      'sticky-header, #header-sticky, .shopify-section-header-sticky, .header-sticky'
    );
    var offset = 0;
    candidates.forEach(function (el) {
      // The sticky element may be the header itself or one of its section wrappers.
      for (var node = el; node && node !== document.body; node = node.parentElement) {
        var position = window.getComputedStyle(node).position;
        if (position === 'sticky' || position === 'fixed') {
          var rect = node.getBoundingClientRect();
          if (rect.bottom > 0 && rect.height < window.innerHeight / 2) offset = Math.max(offset, rect.bottom);
          break;
        }
      }
    });
    return offset;
  }

  function scrollToReviews(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  // Badge link(s) under the product title
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-review-scroll]');
    if (!link) return;
    var target = document.getElementById('customer-reviews');
    if (!target) return;
    event.preventDefault();
    scrollToReviews(target);
    if (link.hasAttribute('data-review-open-form')) {
      var reviews = target.querySelector('product-reviews');
      if (reviews && reviews.openPanel) reviews.openPanel(false);
    }
  });

  class ProductReviews extends HTMLElement {
    connectedCallback() {
      this.perPage = parseInt(this.dataset.perPage, 10) || 5;
      this.page = 1;
      this.list = this.querySelector('[data-review-list]');
      this.cards = this.list ? Array.from(this.list.querySelectorAll('[data-review-card]')) : [];
      this.pagination = this.querySelector('[data-review-pagination]');
      this.panel = this.querySelector('.pr-panel');
      this.toggles = Array.from(this.querySelectorAll('[data-review-toggle]'));

      this.toggles.forEach((btn) => btn.addEventListener('click', () => this.togglePanel()));

      var sort = this.querySelector('[data-review-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          this.sortMode = sort.value;
          this.page = 1;
          this.render();
        });
      }
      this.sortMode = 'recent';
      this.render();

      this.initLightbox();

      var form = this.querySelector('.pr-form');
      if (form) new ReviewForm(form, this);

      // Contact form just posted (page reloaded): show the result.
      if (this.querySelector('[data-review-posted]')) {
        this.openPanel(false);
        scrollToReviews(this.panel);
      }
    }

    /* Panel */
    togglePanel() {
      if (this.panel.hidden) this.openPanel(true);
      else this.closePanel();
    }
    openPanel(focus) {
      this.panel.hidden = false;
      this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
      if (focus) {
        var first = this.panel.querySelector('input[type="radio"], textarea, input:not([type="hidden"])');
        if (first) first.focus({ preventScroll: true });
      }
    }
    closePanel() {
      this.panel.hidden = true;
      this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    }

    /* List: sort, filter, paginate */
    visibleCards() {
      var cards = this.cards.slice();
      var byDate = function (a, b) {
        return Number(b.dataset.date) - Number(a.dataset.date) || Number(b.dataset.order) - Number(a.dataset.order);
      };
      switch (this.sortMode) {
        case 'highest':
          cards.sort(function (a, b) {
            return Number(b.dataset.rating) - Number(a.dataset.rating) || byDate(a, b);
          });
          break;
        case 'lowest':
          cards.sort(function (a, b) {
            return Number(a.dataset.rating) - Number(b.dataset.rating) || byDate(a, b);
          });
          break;
        case 'photos':
          cards = cards.filter(function (c) {
            return Number(c.dataset.photos) > 0;
          });
          cards.sort(byDate);
          break;
        default:
          cards.sort(byDate);
      }
      return cards;
    }

    render() {
      if (!this.list) return;
      var cards = this.visibleCards();
      var pages = Math.max(1, Math.ceil(cards.length / this.perPage));
      this.page = Math.min(this.page, pages);
      var start = (this.page - 1) * this.perPage;
      var shown = cards.slice(start, start + this.perPage);

      this.cards.forEach(function (card) {
        card.hidden = true;
      });
      cards.forEach((card) => this.list.appendChild(card));
      shown.forEach(function (card) {
        card.hidden = false;
      });

      var empty = this.querySelector('[data-review-filter-empty]');
      if (empty) empty.hidden = cards.length > 0;

      this.renderPagination(pages);
    }

    renderPagination(pages) {
      if (!this.pagination) return;
      this.pagination.innerHTML = '';
      if (pages < 2) return;

      var make = (label, page, opts) => {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pr-page';
        btn.innerHTML = label;
        if (opts.ariaLabel) btn.setAttribute('aria-label', opts.ariaLabel);
        if (opts.current) btn.setAttribute('aria-current', 'page');
        if (opts.disabled) btn.disabled = true;
        btn.addEventListener('click', () => {
          this.page = page;
          this.render();
          scrollToReviews(this.list);
        });
        this.pagination.appendChild(btn);
      };

      var prevIcon = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
      var nextIcon = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2"/></svg>';

      make(prevIcon, this.page - 1, { ariaLabel: 'Previous page', disabled: this.page === 1 });
      for (var i = 1; i <= pages; i++) {
        make(String(i), i, { ariaLabel: 'Page ' + i, current: i === this.page });
      }
      make(nextIcon, this.page + 1, { ariaLabel: 'Next page', disabled: this.page === pages });
    }

    /* Lightbox */
    initLightbox() {
      var dialog = this.querySelector('[data-review-lightbox]');
      if (!dialog) return;
      var img = dialog.querySelector('[data-review-lightbox-img]');
      var lastTrigger = null;

      this.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-review-photo]');
        if (!trigger) return;
        lastTrigger = trigger;
        img.src = trigger.dataset.reviewPhoto;
        if (dialog.showModal) dialog.showModal();
        else window.open(trigger.dataset.reviewPhoto, '_blank');
      });
      dialog.querySelector('[data-review-lightbox-close]').addEventListener('click', function () {
        dialog.close();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        img.removeAttribute('src');
        if (lastTrigger) lastTrigger.focus();
      });
    }
  }

  /* Write a review form */
  function ReviewForm(form, root) {
    this.form = form;
    this.root = root;
    this.mode = root.dataset.mode;
    this.workerUrl = (root.dataset.workerUrl || '').replace(/\/$/, '');
    this.photos = [];
    this.video = null;
    this.submitting = false;

    form.noValidate = true;
    this.initStars();
    if (this.mode === 'worker') this.initMedia();
    form.addEventListener('submit', this.onSubmit.bind(this));
    form.addEventListener('input', (event) => {
      var name = event.target.dataset && event.target.dataset.field;
      if (name) this.setError(name, '');
    });
  }

  ReviewForm.prototype.field = function (name) {
    return this.form.querySelector('[data-field="' + name + '"]');
  };

  ReviewForm.prototype.value = function (name) {
    var checked = this.form.querySelector('[data-field="' + name + '"]:checked');
    if (checked) return checked.value;
    var el = this.field(name);
    if (!el || el.type === 'radio') return '';
    return (el.value || '').trim();
  };

  ReviewForm.prototype.setError = function (name, message) {
    var box = this.form.querySelector('[data-error-for="' + name + '"]');
    if (box) {
      box.textContent = message;
      box.hidden = !message;
    }
    this.form.querySelectorAll('[data-field="' + name + '"]').forEach(function (el) {
      if (el.type === 'radio') return;
      if (message) {
        el.setAttribute('aria-invalid', 'true');
        if (box) {
          box.id = box.id || 'pr-err-' + name + '-' + Math.random().toString(36).slice(2, 7);
          el.setAttribute('aria-describedby', box.id);
        }
      } else {
        el.removeAttribute('aria-invalid');
      }
    });
  };

  /* Stars: hover preview + selected state */
  ReviewForm.prototype.initStars = function () {
    var wrap = this.form.querySelector('[data-rating-input]');
    if (!wrap) return;
    var labels = Array.from(wrap.querySelectorAll('.pr-rating-input__star'));
    var paint = function (n) {
      labels.forEach(function (label) {
        label.classList.toggle('is-on', Number(label.dataset.star) <= n);
      });
    };
    var selected = () => Number(this.value('rating')) || 0;
    labels.forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        paint(Number(label.dataset.star));
      });
    });
    wrap.addEventListener('mouseleave', function () {
      paint(selected());
    });
    wrap.addEventListener('change', () => {
      paint(selected());
      this.setError('rating', '');
    });
  };

  /* Photos + video (worker mode) */
  ReviewForm.prototype.initMedia = function () {
    var photoInput = this.form.querySelector('[data-media-input="photos"]');
    var videoInput = this.form.querySelector('[data-media-input="video"]');

    if (photoInput) {
      photoInput.addEventListener('change', () => {
        var files = Array.from(photoInput.files || []);
        photoInput.value = '';
        var error = '';
        files.forEach((file) => {
          if (this.photos.length >= PHOTO_MAX) {
            error = 'You can add up to ' + PHOTO_MAX + ' photos.';
          } else if (PHOTO_TYPES.indexOf(file.type) === -1) {
            error = 'Photos must be JPG, PNG, WEBP or GIF.';
          } else if (file.size > PHOTO_MAX_BYTES) {
            error = 'Each photo must be 20 MB or smaller.';
          } else {
            this.photos.push(file);
          }
        });
        this.setError('photos', error);
        this.renderPreviews('photos');
      });
    }

    if (videoInput) {
      videoInput.addEventListener('change', () => {
        var file = (videoInput.files || [])[0];
        videoInput.value = '';
        if (!file) return;
        var error = '';
        if (VIDEO_TYPES.indexOf(file.type) === -1) error = 'Video must be MP4, MOV or WEBM.';
        else if (file.size > VIDEO_MAX_BYTES) error = 'Video must be 100 MB or smaller.';
        else this.video = file;
        this.setError('video', error);
        this.renderPreviews('video');
      });
    }
  };

  ReviewForm.prototype.renderPreviews = function (kind) {
    var list = this.form.querySelector('[data-media-previews="' + kind + '"]');
    if (!list) return;
    list.querySelectorAll('[data-object-url]').forEach(function (el) {
      URL.revokeObjectURL(el.dataset.objectUrl);
    });
    list.innerHTML = '';
    var files = kind === 'photos' ? this.photos : this.video ? [this.video] : [];

    files.forEach((file, index) => {
      var url = URL.createObjectURL(file);
      var li = document.createElement('li');
      li.className = 'pr-media__item';
      li.dataset.objectUrl = url;
      var media = document.createElement(kind === 'photos' ? 'img' : 'video');
      media.src = url;
      if (kind === 'photos') media.alt = 'Selected photo ' + (index + 1);
      else media.muted = true;
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'pr-media__remove';
      remove.setAttribute('aria-label', kind === 'photos' ? 'Remove photo ' + (index + 1) : 'Remove video');
      remove.innerHTML = '&times;';
      remove.addEventListener('click', () => {
        if (kind === 'photos') this.photos.splice(index, 1);
        else this.video = null;
        this.setError(kind, '');
        this.renderPreviews(kind);
      });
      li.appendChild(media);
      li.appendChild(remove);
      list.appendChild(li);
    });
  };

  /* Validation */
  ReviewForm.prototype.validate = function () {
    var errors = {};
    var rating = Number(this.value('rating'));
    if (!(rating >= 1 && rating <= 5)) errors.rating = 'Please choose a rating.';
    var body = this.value('body');
    if (body.length < 10) errors.body = 'Please write at least 10 characters.';
    if (!this.value('author_name')) errors.author_name = 'Please enter your name.';
    var email = this.value('author_email');
    if (!email) errors.author_email = 'Please enter your email.';
    else if (!EMAIL_RE.test(email)) errors.author_email = 'Please enter a valid email address.';

    ['rating', 'body', 'author_name', 'author_email'].forEach((name) => this.setError(name, errors[name] || ''));

    var firstError = Object.keys(errors)[0];
    if (firstError) {
      var el = this.form.querySelector('[data-field="' + firstError + '"]');
      if (el) el.focus();
      return false;
    }
    return true;
  };

  ReviewForm.prototype.setLoading = function (on) {
    var btn = this.form.querySelector('[data-review-submit]');
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  ReviewForm.prototype.showSuccess = function () {
    var success = this.root.querySelector('[data-review-success]');
    this.form.hidden = true;
    if (success) {
      success.hidden = false;
      success.setAttribute('tabindex', '-1');
      success.focus();
    }
  };

  ReviewForm.prototype.onSubmit = function (event) {
    this.setError('form', '');
    if (this.submitting) {
      event.preventDefault();
      return;
    }
    if (!this.validate()) {
      event.preventDefault();
      return;
    }
    // Honeypot filled: silently pretend it worked.
    if (this.value('website')) {
      event.preventDefault();
      if (this.mode === 'worker') this.showSuccess();
      else this.form.innerHTML = '<p class="pr-success" role="status">Thanks! Your review was submitted and will appear once approved.</p>';
      return;
    }

    if (this.mode !== 'worker') {
      // Email mode: let the native Shopify contact form submit.
      this.submitting = true;
      this.setLoading(true);
      return;
    }

    event.preventDefault();
    this.submitting = true;
    this.setLoading(true);
    this.submitToWorker()
      .then(() => this.showSuccess())
      .catch((error) => {
        if (error && error.fields) {
          Object.keys(error.fields).forEach((name) => this.setError(name, error.fields[name]));
        }
        this.setError('form', (error && error.message) || 'Something went wrong. Please try again.');
      })
      .finally(() => {
        this.submitting = false;
        this.setLoading(false);
      });
  };

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (json) {
          if (!res.ok) {
            var err = new Error(json.error || 'Something went wrong. Please try again.');
            err.fields = json.fields;
            throw err;
          }
          return json;
        });
    });
  }

  ReviewForm.prototype.uploadFiles = function () {
    var files = this.photos.map(function (f) {
      return { file: f, kind: 'photo' };
    });
    if (this.video) files.push({ file: this.video, kind: 'video' });
    if (!files.length) return Promise.resolve({ photos: [], video: null });

    return postJSON(this.workerUrl + '/uploads', {
      files: files.map(function (f) {
        return { filename: f.file.name, mimeType: f.file.type, fileSize: f.file.size, kind: f.kind };
      }),
    }).then(function (res) {
      var targets = res.targets || [];
      if (targets.length !== files.length) throw new Error('Upload could not be prepared. Please try again.');
      return Promise.all(
        targets.map(function (target, i) {
          var data = new FormData();
          (target.parameters || []).forEach(function (p) {
            data.append(p.name, p.value);
          });
          data.append('file', files[i].file);
          return fetch(target.url, { method: 'POST', body: data }).then(function (r) {
            if (!r.ok) throw new Error('A file failed to upload. Please try again.');
            return { kind: files[i].kind, resourceUrl: target.resourceUrl };
          });
        })
      ).then(function (uploaded) {
        return {
          photos: uploaded.filter((u) => u.kind === 'photo').map((u) => u.resourceUrl),
          video: (uploaded.find((u) => u.kind === 'video') || {}).resourceUrl || null,
        };
      });
    });
  };

  ReviewForm.prototype.submitToWorker = function () {
    if (!this.workerUrl) return Promise.reject(new Error('Reviews are not configured yet.'));
    return this.uploadFiles().then((media) =>
      postJSON(this.workerUrl + '/reviews', {
        product_id: this.value('product_id'),
        rating: Number(this.value('rating')),
        body: this.value('body'),
        author_name: this.value('author_name'),
        author_email: this.value('author_email'),
        height_ft: this.value('height_ft'),
        height_in: this.value('height_in'),
        weight: this.value('weight'),
        size_purchased: this.value('size_purchased'),
        fit: this.value('fit'),
        website: this.value('website'),
        photos: media.photos,
        video: media.video,
      })
    );
  };

  if (!customElements.get('product-reviews')) customElements.define('product-reviews', ProductReviews);
})();
